import { useImperativeHandle, forwardRef } from 'react';
import { useGoogleLogin } from '@react-oauth/google';

const GoogleLoginWrapper = forwardRef((props, ref) => {
  const login = useGoogleLogin({
    onSuccess: props.onSuccess,
    onError: props.onError,
    flow: 'implicit',
  });

  useImperativeHandle(ref, () => ({
    triggerLogin: () => login()
  }));

  return null;
});

export default GoogleLoginWrapper;
